/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import "./styles.css";
import AccountsCard from "./accounts";
import ActivitiesCard from "./activities";
import AppsIcon from '@material-ui/icons/Apps';
import ContactsCard from "./contacts";
import IconButton from "@material-ui/core/IconButton";
import NewsCard from "./news";
import TasksCard from "./tasks";
import {Responsive, WidthProvider} from "react-grid-layout";
import {makeStyles} from '@material-ui/core/styles';
import usePersistentStore from "../../persistentStore";
import GettingStartedCard from "./gettingStarted";
import PageBar from "../Common/PageBar";

const availableComponents = {
    gettingStarted: <GettingStartedCard/>,
    tasks: <TasksCard/>,
    news: <NewsCard/>,
    contacts: <ContactsCard/>,
    activities: <ActivitiesCard/>,
    accounts: <AccountsCard/>,
};

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginTop: 10,
    },
    grow: {
        flexGrow: 1,
    },
}));

const Dashboard = props => {
    const classes = useStyles();
    const [layout, setLayout] = useState({lg: []});
    const [components, setComponents] = useState([]);
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();

    const onLayoutChange = (newLayout) => {
        if (globalPersistentState.dashboardWidgets && newLayout.length > 0) {
            let newWidgets = {...globalPersistentState.dashboardWidgets};
            for (let l = 0; l < newLayout.length; l++) {
                const r = newLayout[l];
                if (r.i && newWidgets[r.i]) {
                    newWidgets[r.i] = {
                        ...newWidgets[r.i],
                        unitWidth: r.w,
                        unitHeight: r.h,
                        column: r.x,
                        row: r.y,
                    };
                }
            }
            globalPersistentActions.setDashboardWidgets(newWidgets);
        }
    };

    const handleDashboardReset = () => {
        globalPersistentActions.setDashboardWidgets();
    };

    const initializeComponents = () => {
        const stdDashboardWidth = 12;
        const stdColumns = 2;
        const stdUnitWidth = Math.floor(stdDashboardWidth / stdColumns);
        const stdUnitHeight = 2;
        const stdMinWidth = 2;
        const stdMinHeight = 2;

        let widgetList = {};
        Object.keys(availableComponents).forEach((key, idx) => {
            const newWidget = {
                id: key,
                unitWidth: stdUnitWidth,
                unitHeight: stdUnitHeight,
                column: (idx % stdColumns) * stdUnitWidth,
                row: Math.floor(idx / stdColumns * stdUnitHeight),
                minUnitWidth: stdMinWidth,
                minUnitHeight: stdMinHeight
            };
            widgetList[newWidget.id] = newWidget;
        });
        globalPersistentActions.setDashboardWidgets(widgetList);
    };

    const buildComponents = () => {
        let newLayout = {lg: []};
        let newComponents = [];
        if (globalPersistentState.dashboardWidgets) {
            Object.keys(globalPersistentState.dashboardWidgets).forEach((key, idx) => {
                const widget = globalPersistentState.dashboardWidgets[key];
                const newCard = {
                    w: widget.unitWidth,
                    h: widget.unitHeight,
                    x: widget.column,
                    y: widget.row,
                    i: widget.id,
                    minW: widget.minUnitWidth,
                    minH: widget.minUnitHeight,
                    static: false
                };
                newLayout.lg.push(newCard);
                newComponents.push(widget.id);
            });

            setLayout(newLayout);
            setComponents(newComponents);
        }
    };

    useEffect(() => {
        if (!globalPersistentState.dashboardWidgets || Object.keys(globalPersistentState.dashboardWidgets).length === 0) {
            initializeComponents();
        }
    }, []);

    useEffect(() => {
        if (globalPersistentState.dashboardWidgets && Object.keys(globalPersistentState.dashboardWidgets).length > 0) {
            buildComponents();
        }
    }, [globalPersistentState.dashboardWidgets]);

    return (
        <>
            {globalPersistentState.me && layout && components && (
                <div>
                    <PageBar
                        title={"Dashboard"}
                        dashboardReset
                        handleDashboardReset={handleDashboardReset}
                    >
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="shrink"
                            size="small"
                            onClick={handleDashboardReset}
                        >
                            <AppsIcon/>
                        </IconButton>
                    </PageBar>
                    <div className={classes.root}>
                        <ResponsiveReactGridLayout
                            className="layout"
                            layouts={layout}
                            onLayoutChange={onLayoutChange}
                            draggableHandle=".dragger"
                            breakpoints={{lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0}}
                            cols={{lg: 12, md: 10, sm: 6, xs: 4, xxs: 2}}>
                            {components.map(cName => {
                                return <div id={`pnl-${cName}`} key={cName}>{availableComponents[cName]}</div>;
                            })}
                        </ResponsiveReactGridLayout>
                    </div>
                </div>
            )}
        </>
    );
};

export default Dashboard;
